/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  CreateFeatureFlagMutationRequest,
  CreateFeatureFlagMutationResponse,
} from "../types/CreateFeatureFlag.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const createFeatureFlagMutationKey = () =>
  [{ url: "/v1/feature-flags/create-feature-flag" }] as const

export type CreateFeatureFlagMutationKey = ReturnType<
  typeof createFeatureFlagMutationKey
>

/**
 * {@link /v1/feature-flags/create-feature-flag}
 */
export async function createFeatureFlag(
  data: CreateFeatureFlagMutationRequest,
  config: Partial<RequestConfig<CreateFeatureFlagMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateFeatureFlagMutationResponse,
    ResponseErrorConfig<Error>,
    CreateFeatureFlagMutationRequest
  >({
    method: "POST",
    url: `/v1/feature-flags/create-feature-flag`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function createFeatureFlagMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<CreateFeatureFlagMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = createFeatureFlagMutationKey()
  return mutationOptions<
    ResponseConfig<CreateFeatureFlagMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateFeatureFlagMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return createFeatureFlag(data, config)
    },
  })
}

/**
 * {@link /v1/feature-flags/create-feature-flag}
 */
export function useCreateFeatureFlag<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateFeatureFlagMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: CreateFeatureFlagMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<CreateFeatureFlagMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? createFeatureFlagMutationKey()

  const baseOptions = createFeatureFlagMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<CreateFeatureFlagMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateFeatureFlagMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<CreateFeatureFlagMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateFeatureFlagMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<CreateFeatureFlagMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateFeatureFlagMutationRequest },
    TContext
  >
}
